import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import TopHeader from "components/common/TopHeader";

import { SETTINGS_PATHS } from "constants/routes";

import "./Settings.scss";

function SidebarNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const isActive = (route) => path.includes(route);

  return (
    <ul className="settings-nav-list">
      <li
        className={`settings-nav-item mb-025 ${isActive("manage-users") ? "active" : ""}`}
        onClick={() => navigate(SETTINGS_PATHS.MANAGE_USERS)}
      >
        <div className="para-body-m-regular color-text-heading-primary">Manage users</div>
      </li>
      <li
        className={`settings-nav-item ${isActive("time-off") ? "active" : ""}`}
        onClick={() => navigate(SETTINGS_PATHS.TIME_OFF)}
      >
        <div className="para-body-m-regular color-text-heading-primary">Time-off</div>
      </li>
    </ul>
  );
}

function SettingsLayout({ children, title, linkName, link }) {
  return (
    <div className="settings-container">
      <div className="pl-1 pt-05 settings-header">
        <TopHeader title={title} showBottomBorder={false} linkName={linkName} link={link} breadcrumbs backIcon={link} />
      </div>

      <div className="settings-content">
        <div className="settings-sidebar">
          <div className="para-body-s-regular color-text-body-primary pl-075 ">Settings</div>
          <SidebarNavigation />
        </div>
        <div className="settings-main-content">{children}</div>
      </div>
    </div>
  );
}

export default SettingsLayout;
